"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AMAMLogo = _interopRequireDefault(require("../../../src/images/AMAM-Logo.png"));
var _EMRAMLogo = _interopRequireDefault(require("../../../src/images/EMRAM-Logo.png"));
var _INFRAMLogo = _interopRequireDefault(require("../../../src/images/INFRAM-Logo.png"));
var _OEMRAMLogo = _interopRequireDefault(require("../../../src/images/O-EMRAM-Logo.png"));
var _CISOMLogo = _interopRequireDefault(require("../../../src/images/CISOM-Logo.png"));
var _DIAMLogo = _interopRequireDefault(require("../../../src/images/DIAM-Logo.png"));
var _DHILogo = _interopRequireDefault(require("../../../src/images/DHI-Logo.png"));
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var styles = function styles(_ref) {
  var breakpoints = _ref.breakpoints;
  return {
    paper: {
      borderRadius: 0,
      boxShadow: '0px 0px 20px -2px rgba(0, 0, 0, .75) !important',
      display: 'flex !important',
      flexDirection: 'column !important',
      height: 'auto !important',
      padding: '1rem !important',
      justifyContent: 'space-between !important',
      textAlign: 'center'
    },
    sixteenByTwentyFive: {
      paddingBottom: '120% !important',
      '@media (min-width: 1200px)': {
        paddingBottom: '90% !important'
      }
    },
    amamPadding: {
      paddingBottom: '135% !important',
      '@media (min-width: 1250px)': {
        paddingBottom: '100% !important'
      }
    },
    sidebarModelTitle: (0, _defineProperty2["default"])({
      color: '#1a25ab',
      fontSize: '1.5rem !important',
      fontFamily: 'Verlag Bold',
      fontWeight: '600 !important',
      lineHeight: '1.33 !important',
      fontStyle: 'italic',
      justifyContent: 'left',
      textAlign: 'left'
    }, breakpoints.down(901), {
      fontSize: '1.2rem !important',
      lineHeight: '1.2 !important'
    }),
    sidebarModelText: (0, _defineProperty2["default"])({
      justifyContent: 'left',
      textAlign: 'left',
      fontSize: '1.2rem !important',
      lineHeight: '1 !important',
      marginTop: '10px !important'
    }, breakpoints.down(901), {
      fontSize: '1.0rem !important'
    }),
    sidebarModelTextBlue: {
      color: '#1a25ab'
    },
    sidebarModelBubbles: {
      alignItems: 'left',
      justifyContent: 'left',
      textAlign: 'left',
      marginTop: '12px !important',
      whiteSpace: 'normal'
    },
    sidebarModelBubble: {
      alignItems: 'left',
      justifyContent: 'left',
      textAlign: 'left',
      fontSize: '.8rem !important',
      backgroundColor: '#FF585F',
      borderRadius: '16px',
      margin: '2px !important',
      padding: '4px !important',
      paddingLeft: '6px !important',
      paddingRight: '6px !important',
      width: 'auto',
      position: 'relative',
      display: 'inline-block'
    },
    stageNumber: {
      color: '#1a25ab',
      alignItems: 'center',
      backgroundColor: '#eaeaea',
      display: 'flex',
      height: '16px',
      justifyContent: 'center',
      width: '16px',
      minWidth: '16px',
      borderRadius: '21px',
      padding: '7px',
      margin: 'auto',
      marginRight: '10px',
      marginLeft: '10px',
      fontFamily: 'Verlag Bold'
    },
    stageNumberSelected: {
      alignItems: 'center',
      backgroundColor: '#eaeaea',
      display: 'flex',
      height: '16px',
      justifyContent: 'center',
      width: '16px',
      minWidth: '16px',
      color: '#FF585F',
      borderRadius: '21px',
      padding: '7px',
      margin: 'auto',
      marginRight: '10px',
      marginLeft: '10px',
      fontFamily: 'Verlag Bold'
    },
    stageIcon: (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, breakpoints.down('lg'), {
      height: '1.5rem'
    }), breakpoints.up('lg'), {
      height: '2rem'
    }),
    titleContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-around',
      width: '100%'
    },
    title: {
      color: '#707070',
      fontSize: '1.1rem',
      '@media (min-width: 1200px)': {
        fontSize: '1.5rem',
        marginTop: '.5rem'
      }
    },
    widgetContainer: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0
    },
    wrapper: {
      marginBottom: '3rem',
      position: 'relative',
      width: '100%'
    },
    thankYouText: (0, _defineProperty2["default"])({
      color: '#000',
      fontWeight: 500
    }, breakpoints.up('sm'), {
      lineHeight: 1.5,
      fontSize: '0.8rem',
      margin: '10px 0px'
    }),
    smallText: {
      lineHeight: 1,
      marginBottom: '.25rem'
    },
    stageLine: {
      width: '100%',
      display: 'flex',
      paddingTop: '6px',
      paddingBottom: '6px',
      minHeight: '42px' //this is the Height of a section with three lines, they should all be this Height to keep numbers spaced evenly
    },
    stageLineSelected: {
      backgroundColor: '#FF585F',
      width: '100%',
      display: 'flex',
      paddingTop: '6px',
      paddingBottom: '6px',
      minHeight: '42px'
    },
    stageText: {
      display: 'flex',
      fontSize: '0.7rem',
      color: '#000',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'Verlag Bold',
      fontWeight: '400',
      paddingRight: '20px'
    },
    stageTextSelected: {
      display: 'flex',
      fontSize: '0.7rem',
      color: '#FFF',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'Verlag Bold',
      fontWeight: '400',
      paddingRight: '20px'
    }
  };
};
var getScoringImageURL = function getScoringImageURL(type) {
  switch (type) {
    case 'O-EMRAM':
      return _OEMRAMLogo["default"];
    case 'EMRAM':
      return _EMRAMLogo["default"];
    case 'INFRAM':
      return _INFRAMLogo["default"];
    case 'AMAM':
      return _AMAMLogo["default"];
    case 'AMAM 2024':
      return _AMAMLogo["default"];
    case 'CISOM':
      return _CISOMLogo["default"];
    case 'DIAM':
      return _DIAMLogo["default"];
    case 'DHI':
      return _DHILogo["default"];
    case 'DHIShort':
      return _DHILogo["default"];
    case 'DHI for CCMM':
      return _DHILogo["default"];
    case 'GDHP':
      return '';
    case 'EMRAM 2022':
      return '';
    case 'CCMM':
      return '';
    case 'C-COMM':
      return '';
    default:
      return _EMRAMLogo["default"];
  }
};
var ScoringCard = function ScoringCard(_ref2) {
  var classes = _ref2.classes,
    scoringType = _ref2.scoringType,
    resources = _ref2.resources,
    language = _ref2.language;
  return /*#__PURE__*/_react["default"].createElement(_material.Paper, {
    className: classes.paper
  }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, scoringType !== 'GDHP' && scoringType !== 'EMRAM 2022' && scoringType !== 'CCMM' && scoringType !== 'C-COMM' && scoringType !== 'INFRAM 2024' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    style: scoringType === 'DHI' || scoringType === 'DHI for CCMM' || scoringType === 'DHIShort' ? {
      height: '7.75rem'
    } : {
      height: '3.75rem'
    },
    src: getScoringImageURL(scoringType),
    alt: "".concat(scoringType, " Logo")
  })), scoringType === 'EMRAM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgEmramWidget', ''))) : scoringType === 'INFRAM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgInframWidget', ''))) : scoringType === 'O-EMRAM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgOemramWidget', ''))) : scoringType === 'AMAM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgAmamWidget', ''))) : scoringType === 'CISOM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgCisomWidget', ''))) : scoringType === 'DIAM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgDiamWidget', ''))) : scoringType === 'DHI' || scoringType === 'DHI for CCMM' || scoringType === 'DHIShort' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgDhiWidget', ''))) : scoringType === 'GDHP' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msggdhpWidget', ''))) : scoringType === 'EMRAM 2022' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelTitle
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Electronic Medical Record Adoption Model')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'Label', 'EMRAM is a whole hospital model that includes inpatient, outpatient and day case services provided on the hospital campus. As healthcare organizations harness technology and data to optimize care, they move closer to achieving near paperless environments.')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: "".concat(classes.sidebarModelText, " ").concat(classes.sidebarModelTextBlue)
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Measures EMR impacts on systems and patients -')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'Label', 'improve patient safety and care quality through')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: 'div',
    variant: "body2",
    className: classes.sidebarModelBubbles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#E3A2E2'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'improved operational performance')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#FFDD80'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'reduced errors')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#8AE6CF'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'reduced length of stay')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#4dc0e8'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'increased patient engagement')))) : scoringType === 'CCMM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelTitle
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Continuity of Care Maturity Model')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'Label', 'CCMM addresses care delivery and collaboration among healthcare providers across sectors (e.g., primary care providers, acute care providers, long-term care facilities). By enabling coordination of patient care, enhancing health information exchange, advancing analytics capabilities, and establishing patient engagement, a care partnership is evolving into a patient-centered care community.')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: "".concat(classes.sidebarModelText, " ").concat(classes.sidebarModelTextBlue)
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Measures interconnectivity of healthcare within multi-organizational frameworks')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: 'div',
    variant: "body2",
    className: classes.sidebarModelBubbles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#E3A2E2'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Foster a comprehensive approach to integrated care')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#FFDD80'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Identify gaps in capacity')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#8AE6CF'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Achieve closed loop care coordination across all care team members')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#4dc0e8'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Understand the position of each other')))) : scoringType === 'C-COMM' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelTitle
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Community Care Outcomes Maturity Model')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'Label', 'The C-COMM is a flexible model designed to support non-acute healthcare delivery across the life course. As more non-acute healthcare organizations become digitally-enabled, C-COMM will measure digital processes and associated outcomes, and the foundational elements of digital maturity that every organization requires to advance their performance, strengthen care delivery, and build capacity to deliver quality care well into the future.')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: "".concat(classes.sidebarModelText, " ").concat(classes.sidebarModelTextBlue)
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Measuring Digital Maturity to: ')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: 'div',
    variant: "body2",
    className: classes.sidebarModelBubbles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#E3A2E2'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Advance & Strengthen Health Outcomes')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#FFDD80'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Improve Organizational Capacity')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#8AE6CF'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Proactively Manage Risks')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#4dc0e8'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Establish Resiliency')))) : scoringType === 'INFRAM 2024' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelTitle
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Infrastructure Adoption Model')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'Label', "INFRAM is a framework for evaluating the value delivered by technology investments. As healthcare institutions increasingly depend on technology and data to enhance care, it becomes crucial to recognize any disparities between their strategic goals and the infrastructure's actual capabilities.")), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: 'div',
    variant: "body2",
    className: classes.sidebarModelBubbles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#E3A2E2'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Assess Cybersecurity Risks')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#FFDD80'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Measure IT Performance')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#8AE6CF'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Evaluate Adoption')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#4dc0e8'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Improve Operational Outcomes')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#ff5959'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Introduce Sustainability')))) : scoringType === 'AMAM 2024' ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'Label', "The Analytics Maturity Assessment Model (AMAM) offers support and guidance to health organizations to realize the full potential of analytics in health systems to advance and strengthen health system performance, personalized and equitable care, and financial sustainability.")), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: 'div',
    variant: "body2",
    className: classes.sidebarModelBubbles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#E3A2E2'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Responsible analytics')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#FFDD80'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Equitable care outcomes')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#8AE6CF'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Data-driven decisions')), /*#__PURE__*/_react["default"].createElement("div", {
    variant: "body2",
    className: classes.sidebarModelBubble,
    style: {
      backgroundColor: '#4dc0e8'
    }
  }, (0, _getResource.getResource)(resources, language, 'Label', 'Personalized care')))) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    className: classes.sidebarModelText
  }, (0, _getResource.getResource)(resources, language, 'msgEmramWidget', '')))));
};
ScoringCard.propTypes = {
  scoringType: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(ScoringCard);